import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query TableDownstreamPublishedDatasourcesFilteredByColumnWithoutPersonalSpaceQuery(
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  columns(filter: {id: $columnId}) {
    downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
